import { render, staticRenderFns } from "./Pos_product_empty.vue?vue&type=template&id=173a2550&scoped=true&"
import script from "./Pos_product_empty.vue?vue&type=script&lang=js&"
export * from "./Pos_product_empty.vue?vue&type=script&lang=js&"
import style0 from "./Pos_product_empty.vue?vue&type=style&index=0&id=173a2550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a2550",
  null
  
)

export default component.exports